// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"77":"6e55ee9855a10561","119":"ea21f8c02a5f5e6a"}[chunkId] + ".css";
};